import React from "react"
type Props = {
  name: string
  post: string
  videoUrl: any
  id: any
  onPlay: any
}
const TestimonialVideo: React.FC<Props> = ({
  name,
  post,
  videoUrl,
  id,
  onPlay,
}) => {
  return (
    <div
      className="card p-[30px] bg-white rounded-10 border w-full mb-10"
      data-aos="fade-up"
      data-aos-duration="700"
      data-aos-delay="300"
    >
      <div className="card-body">
        <div className="video-wrapper mb-5">
          <video
            id={id}
            className="rounded-10"
            controls
            controlsList="nodownload"
            onPlay={onPlay}
          >
            <source type="video/webm" src={videoUrl} />
          </video>
        </div>
        <p className="card-title fs-lg fw-700 mb-0 text-textcolor">{name}</p>
        <p className="card-text fs-md fw-600 text-secondary mb-0 mt-2">{post}</p>
      </div>
    </div>
  )
}

export default TestimonialVideo
